export const CURRENT_JUDICIARY_STEP_JUDGEMENT_ON_MERITS = 2;

export const INCIDENT_TYPE = {
  VICTIM: 'victim',
  VEHICLE: 'vehicule',
};
